import styles from "../../components/Block/Block.module.scss";
import {Button, Block} from "../../components";
import {useState} from "react";
import cn from "classnames";
import stylesButton from "../../components/Button/Button.module.scss";

const text = "Введи свой E-mail, чтобы мы могли связаться с тобой";

export const SecondBlock = ({handler, onChange, emailValue, type}) => {
    const [success, setStep] = useState(false);
    const buttonType = !success ? 'disabled' : 'active';

    const test = email => {
        //eslint-disable-next-line
        return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email));
    }

    const error = () => {
        setStep(false);
        document.querySelector('.input-email').classList.add('error');
    }

    return (
        <Block name="box-blue-12" title="" desc="">
            <div className={styles.someText}>{text}</div>
            <div className={styles.form}>
                <div className={cn(styles.wrap, type ? styles.active : '', "input-email")}>
                    <input placeholder="" type="text" onChange={(e) => {onChange(e.target.value, "email", setStep)}} value={emailValue} className={styles.input}/>
                    {emailValue !== '' ? <div onClick={() => onChange("", "email", setStep)} className={styles.cross}/> : ''}
                </div>
            </div>
            <Button id="button-next-1" text="Далее" className={stylesButton.email}  handler={test(emailValue) ? handler : error} type={buttonType}/>
        </Block>
    )
}